import { useEffect, useState } from 'react';

const DISMISSED_KEY = 'install_banner_dismissed';

export function InstallBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent;
    const isIOS = /iPad|iPhone|iPod/.test(ua) && !(window as Window & { MSStream?: unknown }).MSStream;
    const isSafari = /Safari\//.test(ua) && !/CriOS\//.test(ua) && !/FxiOS\//.test(ua);
    const isPWA =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.matchMedia('(display-mode: fullscreen)').matches ||
      (navigator as Navigator & { standalone?: boolean }).standalone === true;
    const dismissed = localStorage.getItem(DISMISSED_KEY) === '1';

    if (isIOS && isSafari && !isPWA && !dismissed) {
      // Small delay so it doesn't flash on load
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISSED_KEY, '1');
    setVisible(false);
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 'max(1.25rem, env(safe-area-inset-bottom, 1.25rem))',
        left: '1rem',
        right: '1rem',
        zIndex: 9999,
        background: 'rgba(15,10,40,0.92)',
        border: '1px solid rgba(255,255,255,0.12)',
        borderRadius: '1rem',
        padding: '0.875rem 1rem',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        color: '#fff',
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: '0.8125rem', fontWeight: 600, marginBottom: '0.2rem', color: '#f0e6ff' }}>
          Install for fullscreen
        </div>
        <div style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.55)', lineHeight: 1.4 }}>
          Tap{' '}
          <svg
            style={{ display: 'inline', verticalAlign: 'middle', marginBottom: 2 }}
            width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="rgba(139,92,246,1)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"
          >
            <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
            <polyline points="16 6 12 2 8 6" />
            <line x1="12" y1="2" x2="12" y2="15" />
          </svg>
          {' '}then <strong style={{ color: '#c4b5fd' }}>"Add to Home Screen"</strong>
        </div>
      </div>
      <button
        onClick={dismiss}
        style={{
          flexShrink: 0,
          background: 'rgba(255,255,255,0.08)',
          border: '1px solid rgba(255,255,255,0.12)',
          borderRadius: '50%',
          width: 28,
          height: 28,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'rgba(255,255,255,0.5)',
          cursor: 'pointer',
          fontSize: '1rem',
          lineHeight: 1,
        }}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
}
